module.exports = __webpack_public_path__ + "img/ic_zbdj_ok.c63e65d4.png";